import { Cloud, Thermometer, Droplets, Wind } from 'lucide-react';

interface WeatherCardProps {
  data: {
    city?: string;
    temp?: number;
    feels_like?: number;
    conditions?: string;
    humidity?: number;
    wind_speed?: number;
    icon?: string;
  };
}

export default function WeatherCard({ data }: WeatherCardProps) {
  return (
    <div className="my-2 border border-cyan-500/30 bg-[#0a1628]/80 backdrop-blur-sm p-3 max-w-[280px]"
         style={{ clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))' }}>
      <div className="flex items-center gap-2 mb-2">
        <Cloud className="w-4 h-4 text-cyan-400" />
        <span className="text-cyan-300 font-semibold text-sm">{data.city || 'Weather'}</span>
      </div>

      <div className="flex items-end gap-2 mb-2">
        <span className="text-3xl font-mono text-white">{data.temp ? `${Math.round(data.temp)}°` : '--'}</span>
        <span className="text-gray-400 text-xs mb-1">{data.conditions || ''}</span>
      </div>

      <div className="grid grid-cols-3 gap-2 text-xs">
        {data.feels_like !== undefined && (
          <div className="flex items-center gap-1 text-gray-300">
            <Thermometer className="w-3 h-3 text-cyan-500/70" />
            <span className="font-mono">{Math.round(data.feels_like)}°</span>
          </div>
        )}
        {data.humidity !== undefined && (
          <div className="flex items-center gap-1 text-gray-300">
            <Droplets className="w-3 h-3 text-cyan-500/70" />
            <span className="font-mono">{data.humidity}%</span>
          </div>
        )}
        {data.wind_speed !== undefined && (
          <div className="flex items-center gap-1 text-gray-300">
            <Wind className="w-3 h-3 text-cyan-500/70" />
            <span className="font-mono">{data.wind_speed}</span>
          </div>
        )}
      </div>
    </div>
  );
}
